<template>
    <el-container style="height: 100%;">
        <el-header style="height: 50px; background: #252a2f; color: #ffffff; ">
            <top-header/>
        </el-header>
        <el-container style="height: calc(100% - 50px);">
            <el-aside width="auto" style="height: 100%;">
                <side-menu/>
            </el-aside>
            <el-main style="padding: 0px; height: 100%;">
                <tab-layout/>
            </el-main>
        </el-container>
<!--        <el-footer style="background: #373d41; color: #ffffff;">Footer</el-footer>-->
    </el-container>
</template>
<script>
import TopHeader from './component/TopHeader';
import SideMenu from './component/SideMenu';
import TabLayout from './component/TabLayout';
export default {
    name: 'Index',
    data()
    {
        return {
        }
    },
    methods:
    {

    },
    components:
    {
        TopHeader,
        SideMenu,
        TabLayout
    },
    beforeMount()
    {

    },
    mounted()
    {
        return Fx.Http.post("/system/user/getPermissions").
        then((response)=>
        {
            console.log('permissions:', response);
            this.$store.commit('session/setUserPermissionIdList', response.getData("userPermissionIdList"));
            this.$store.commit('session/setUserPermissionGroupIdList', response.getData("userPermissionGroupIdList"));
        }).
        then(()=>
        {
            this.$store.dispatch('layout/initMenu');
            // console.log('index mounted', this.$route);
            //@TODO 修改打开方式
            this.$store.dispatch('layout/openTab',{caption: '工作台', path: '/dashboard', closable: false});
            if(this.$route.path != '/')
            {
                this.$store.dispatch('layout/openTab',{caption: this.$route.meta.caption, path: this.$route.fullPath, closable: true});
            }
        });
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/modules/common/pages/index/Index.vue